import { AbstractFWGlobalParams } from 'tag/ts/tag/ads/freewheel/abstract/AbstractFWGlobalParams';
import { IFWPauseAdGlobalParams } from 'tag/ts/tag/interfaces/ads/pause/IFWPauseAdGlobalParams';
import { IFWPauseAdGlobalParamsArgument } from 'tag/ts/tag/interfaces/arguments/IFWPauseAdGlobalParamsArgument';

/**
 * @copyright © Paramount Streaming
 * @description Freewheel global parameters for pause ads
 */
export class FWPauseAdGlobalParams extends AbstractFWGlobalParams {

	/**
	 * @description Internal store for global ad parameters
	 * @type {IFWPauseAdGlobalParams}
	 * @readonly
	 */
	protected readonly adParams: IFWPauseAdGlobalParams;

	constructor( argument: IFWPauseAdGlobalParamsArgument ) {
		super(
			{
				name: 'FWPauseAdGlobalParams',
				...argument
			}
		);

		this.adParams = this.#overrideParams( this.#createParams(), argument?.paramsOverride );
	}

	/**
	 * @description Creates global parameters for pause ads
	 * @returns {IFWPauseAdGlobalParams}
	 */
	#createParams(): IFWPauseAdGlobalParams {
		const params: IFWPauseAdGlobalParams = {
			asnw: this.fwConstants.assetNetworkId,
			caid: this.apiMetadata?.contentId,
			csid: this.siteSessionData?.csid?.toLowerCase() || this.createSiteSectionId(),
			flag: this.pauseAdConstants.capabilitiesFlag,
			metr: this.fwConstants.defaultCapabilities,
			nw: this.fwConstants.networkId,
			prof: this.fwConstants.playerProfile,
			pvrn: this.pauseAdConstants.pageView,
			resp: this.pauseAdConstants.response,
			ssnw: this.fwConstants.siteSectionNetworkId,
			vprn: this.pauseAdConstants.videoPlayer
		};
		this.logger?.log( 'createParams:', params );
		return params;
	}

	/**
	 * @description Overrides values in params
	 * @returns {IFWPauseAdGlobalParams}
	 */
	#overrideParams( params: IFWPauseAdGlobalParams, overrides: IFWPauseAdGlobalParams ): IFWPauseAdGlobalParams {
		// null check
		if (
			this.utils?.Type?.isEmpty( params ) ||
			this.utils?.Type?.isEmpty( overrides )
		) {
			return params;
		}

		// set param values to overrides, if key is present in params and override value is defined
		Object.entries( overrides ).forEach( ( [ key, value ] ) => {
			if (
				params[ key ] &&
				!this.utils?.Type?.isEmpty( value )
			) {
				const prevValue = params[ key ];
				params[ key ] = value;
				this.logger?.log( 'overrideParams:', 'parameter overridden...', '\nkey:', key, '\nprevious value:', prevValue, '\nnew value:', params[ key ] );
			}
		} );
		this.logger?.log( 'overrideParams:', params );
		return params;
	}

	/**
	 * @description Returns global parameters for pause ads
	 * @returns {IFWPauseAdGlobalParams}
	 */
	get adParameters(): IFWPauseAdGlobalParams {
		return this.adParams;
	}
}